<template>
    <div class="overflow-hidden bb-profile-block shadow rounded-lg mb-6">
        <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
                {{ data.booking_reference }}
            </h3>
            <div
                class="bg-blue-500 text-white rounded-lg px-2 text-sm font-bold inline-block"
            >
                {{ data.state.status }}
            </div>
        </div>
        <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl class="sm:divide-y sm:divide-gray-200">
                <div
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Stay
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        {{ data.nights }} nights,
                        <span class="mr-3"
                            >from <b>{{ format(data.start) }}</b> to
                            <b>{{ format(data.end) }}</b></span
                        >
                    </dd>
                </div>
                <div
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Guests
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        {{ data.number_of_adults }}
                        {{ data.number_of_adults > 1 ? "adults" : "adult" }}
                        <span v-if="data.number_of_children" class="ml-3">
                            {{ data.number_of_children }}
                            {{
                                data.number_of_children > 1
                                    ? "children"
                                    : "child"
                            }}
                        </span>
                    </dd>
                </div>
                <div
                    class="flex flex-row items-center bg-blue-100 px-4 py-2 text-gray-400 font-semibold cursor-pointer"
                    @click="expanded = true"
                    v-if="!expanded"
                >
                    <div class="mr-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 9l-7 7-7-7"
                            />
                        </svg>
                    </div>
                    <div>View more information</div>
                </div>

                <div
                    v-if="expanded && data.spaces.length"
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Room
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        <div v-for="(space, key) in data.spaces" :key="key">
                            {{ space.name }}
                            <span v-if="space.floor" class="ml-3"
                                >Floor {{ space.floor }}</span
                            >
                            <span v-if="space.number" class="ml-3"
                                >Nr. {{ space.number }}</span
                            >
                        </div>
                    </dd>
                </div>
                <!--                <div
                    v-if="expanded && data.rate_plans.length"
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">
                        Rates
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        <div v-for="(rate, key) in data.rate_plans" :key="key">
                            <div>{{ rate.name }}</div>
                        </div>
                    </dd>
                </div>-->
                <div
                    v-if="expanded"
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                >
                    <dt class="text-sm font-medium text-gray-500">Balance</dt>
                    <dd
                        class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                    >
                        Total:
                        <b class="mr-3"
                            >{{ data.currency }}{{ data.total_gross_amount }}</b
                        >
                        Open: <b>{{ data.currency }}{{ data.balance }}</b>
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script>
export default {
    name: "Reservation",
    props: ["data"],
    methods: {
        format(datetime) {
            return new Date(datetime).toLocaleDateString();
        }
    },
    data() {
        return {
            expanded: false
        };
    },
    async mounted() {}
};
</script>
<style>
.bb-profile-block {
    background: var(--profile-card-background-color);
}
</style>

